<template>
  <div class="module">
    <div style="margin-bottom: 8px">
      <span> Copyright  2021 江门市链想力科技有限公司 版权所有 <span class="ICP" @click="click">粤ICP备2021068188号</span> </span>
      <span class="click-span" @click="navClick(0)">免责声明</span>
      <span class="click-span" @click="navClick(1)">隐私政策</span>
      <span class="click-span" @click="navClick(2)">服务条款</span>
      <span class="click-span" @click="navIntroduct">关于我们 </span>
<!--      <span> Copyright  2020-2030 WWW.AMZJOIN.COM 版权所有 <span class="ICP" @click="click">粤ICP备2021068188号</span> &nbsp;&nbsp;&nbsp;</span>-->
<!--      <span> Copyright  2020-2030 江门市链想力科技有限公司 版权所有 <span class="ICP" @click="click">粤ICP备2021068188号</span> &nbsp;&nbsp;&nbsp;</span>-->
      <!-- <span id='cnzz_stat_icon_1279474486'></span>
      <remote-script src="https://s4.cnzz.com/z_stat.php?id=1279474486&show=pic"></remote-script> -->
      <span id='cnzz_stat_icon_1280727273'></span>
      <remote-script src="https://s9.cnzz.com/z_stat.php?id=1280727273&show=pic"></remote-script>
<!--      <span class="contact" @click="navIntroduct">联系我们</span>-->
    </div>
<!--    <span>-->
<!--      声明：网站上小图标对应的链接由第三方提供信息服务,与AMZJOIN无关.请用户注意辨别。-->
<!--    </span>-->
    <span class="bottom-context">渠道合作：13380967750</span>
    <span class="bottom-context">联系电话：0750-3228845</span>
    <span class="bottom-context">投诉,建议或反馈：info@matrixdeal.com</span>
  </div>
</template>

<script>
  import 'common/importJS'

  export default {
    name: "copyright",
    methods:{
      click(){
        window.open('https://beian.miit.gov.cn/#/Integrated/index')
      },
      navIntroduct(){
        this.$router.push('/introduce')
      },
      navClick(index){
        if(index === 0){
          window.open('/law/WhaleERP免责声明.html')
        }else if(index === 1){
          window.open('/law/WhaleERP隐私政策.html')
        }else if(index === 2){
          window.open('/law/WhaleERP用户服务条款.html')
        }
      }
    }
  }
</script>

<style scoped>
  .module{
    margin: 20px 0;
    text-align: center;
  }

  .module span{
    font-size: 12px;
  }

  .ICP{
    cursor: pointer;
    /*color: #19ACFD;*/
    /*text-decoration: #19ACFD solid underline;*/
  }

  .ICP:hover{
    cursor: pointer;
    color: #ff7f17;
  }

  .contact{
    color: #19ACFD;
    margin-left: 3px;
  }

  .contact:hover{
    cursor: pointer;
    opacity: .8;
  }

  .click-span{
    margin: 0 0 0 5px;
  }

  .click-span:hover{
    cursor: pointer;
    color: #ff7f17;
  }

  .bottom-context{
    margin-right: 10px;
  }
</style>
